// Dependencies
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter, RouteComponentProps} from "react-router-dom";

// Components
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

// Store
import {SystemServerVersionsActionCreators} from "../../actions/actionCreators";
import {SystemServerVersionsStoreSelectors} from "../../store/store";
import {ActionCreator} from "../../../../actions/actions";

// Styles
import "./SystemServerVersionsList.component.scss";


export interface SystemServerVersionsListProps extends RouteComponentProps {
    getSystemServerVersions: ActionCreator;
    systemServerVersions: any;
    systemServerVersionsLoading: boolean;
    toggleSystemServerVersionStatus: ActionCreator;
}

export interface SystemServerVersionsListState {
}

class SystemServerVersionsList extends Component<
    SystemServerVersionsListProps,
    SystemServerVersionsListState
> {
    constructor(props) {
        super(props);
        this.props.getSystemServerVersions();
    }

    render() {
        return (
            <div id="SystemServerVersionsList" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2>System Server Versions</h2>
                        </div>
                    </div>
                    <div className="system-server-versions-list">
                        {this.props.systemServerVersionsLoading ? (
                            <div className="system-server-versions-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="row">
                                {this.props.systemServerVersions && this.props.systemServerVersions.map(
                                    (version, key) => {
                                        return (
                                            <div
                                                className="system-server-versions-card"
                                                key={key}
                                            >
                                                <div className="system-server-versions-card-body">
                                                    <span>
                                                        <p>Version: </p>
                                                        {version.version}
                                                    </span>
                                                </div>
                                                <div className="system-server-versions-card-footer">
                                                    <div className="system-server-versions-card-status">
                                                        <span>
                                                            {version.active ? "Active" : "Inactive"}
                                                        </span>
                                                        <Components.Switch
                                                            onClick={()=>
                                                                this.props.toggleSystemServerVersionStatus(version.id, !version.active)
                                                            }
                                                            on={version.active}
                                                            enabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
            ;
    }
}

const mapStateToProps = state => ({
    systemServerVersions: SystemServerVersionsStoreSelectors.systemServerVersions(state),
    systemServerVersionsLoading: SystemServerVersionsStoreSelectors.systemServerVersionsLoading(state)
});

const mapDispatchToProps = {
    getSystemServerVersions: SystemServerVersionsActionCreators.getSystemServerVersions,
    toggleSystemServerVersionStatus: SystemServerVersionsActionCreators.toggleSystemServerVersionStatus,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SystemServerVersionsList));
